import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  background: #fff0e2;
  background-image: linear-gradient(164deg, #fff0e2 30%, #ffffff);

  .blog-container {
    .banner {
      position: relative;
      height: 480px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 40px;

      .shadow {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(112, 112, 112, 0.3);
        z-index: 1;
      }

      .cover-image {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .title {
        position: relative;
        color: ${theme.white};
        z-index: 2;
      }
    }

    .ant-tabs {
      .ant-tabs-nav {
        margin: 0 0 20px 0;
      }
      .ant-tabs-nav::before {
        border-bottom: 2px solid #c2c2c2;
      }
      .ant-tabs-tab-btn {
        color: ${theme.darkRed};
        font-size: 20px;
      }
      .ant-tabs-ink-bar {
        height: 2px;
        background: ${theme.darkRed};
      }
    }

    .blog-content {
      margin-top: 45px;

      .most-popular {
        .title {
          border-bottom: 2px solid #c2c2c2;
          text-align: center;
          padding-bottom: 10px;
          margin-bottom: 30px;

          .ant-typography {
            color: ${theme.darkRed};
          }
        }

        .ant-divider {
          border-top: 2px solid #c2c2c2;
        }
      }

      .review {
        position: relative;
        margin-top: 100px;

        .title {
          position: relative;
          border-bottom: 2px solid #c2c2c2;
          padding-bottom: 10px;
          margin-bottom: 30px;

          &:after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 80px;
            height: 2px;
            background-color: ${theme.darkRed};
          }

          .ant-typography {
            color: ${theme.darkRed};
          }
        }

        .carousel-button-block {
          position: absolute;
          top: 5px;
          right: 0;
          z-index: 2;
          display: flex;

          .carousel-button {
            border: 3px solid ${theme.darkRed};
            width: 30px;
            height: 30px;
            border-radius: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            svg {
              color: ${theme.darkRed};
            }

            &.carousel-button-prev {
              margin-right: 20px;
              svg {
                transform: rotate(180deg);
              }
            }

            &.swiper-button-disabled {
              opacity: 0.3;
              border: 3px solid #282828;
              svg {
                color: #282828;
              }
            }
          }
        }
      }

      .article-content {
        margin-top: 100px;
        margin-bottom: 50px;
        .title {
          position: relative;
          border-bottom: 2px solid #c2c2c2;
          padding-bottom: 8px;

          &:after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 80px;
            height: 2px;
            background-color: ${theme.darkRed};
          }

          .ant-typography {
            color: ${theme.darkRed};
          }
        }
      }

      .category-name {
        color: ${theme.darkRed};
      }

      .grid-container {
        .button-block {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 10px;

          .ant-space-item {
            display: flex;
            align-items: center;
          }

          .text-button {
            color: ${theme.black};
          }

          .icon-button {
            color: ${theme.black};
            font-size: 15px;
          }
        }
      }

      .categories-block {
        .category-block {
          margin-bottom: 60px;
          .sub-categories-container {
            margin-top: 20px;
          }
        }
      }
    }

    .section-subscribe {
      margin-top: 140px;
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .blog-container {
      .blog-content {
        margin-top: 20px;
        .categories-block {
          .category-block {
            .sub-categories-container {
            }
            .grid-container {
            }
            .button-block {
              justify-content: flex-end;
            }
          }
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .blog-container {
      .title {
        margin-top: 10px;
      }

      .blog-content {
        margin-top: 10px;
        .categories-block {
          .category-block {
            margin-bottom: 30px;
            .sub-categories-container {
            }
            .grid-container {
            }
            .button-block {
              justify-content: flex-end;
            }
          }
        }
      }
    }
  }
`
